import React, { useEffect, useState } from "react";
import YouTube from "react-youtube";
import { YouTubePlayer } from "youtube-player/dist/types";
import styles from "./YoutubeVideoIframe.module.css";

type Props = {
  youtubeId: string;
};

export const YoutubeVideoIframe: React.FC<React.PropsWithChildren<Props>> = ({
  youtubeId,
}) => {
  const [player, setPlayer] = useState<YouTubePlayer>();
  const [ended, setEnded] = useState(false);

  useEffect(() => {
    setEnded(false);
  }, [youtubeId]);

  return (
    <button
      className={styles.playerWrapper}
      aria-label="Restart video"
      onClick={async () => {
        if (ended) {
          await player?.playVideo();
        }
      }}
    >
      <YouTube
        videoId={youtubeId}
        iframeClassName={ended ? styles.playerContainer : undefined}
        className={styles.player}
        opts={{
          playerVars: {
            rel: 0,
          },
        }}
        onReady={(e) => {
          setPlayer(e.target);
        }}
        onPlay={() => {
          setEnded(false);
        }}
        onEnd={() => {
          setEnded(true);
          if (document.fullscreenElement) {
            void document.exitFullscreen();
          }
        }}
      />
    </button>
  );
};
